<template>
  <div
    class="template"
    v-if="
      selectedBot &&
      (!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin'))
    "
  >
    <main-layout>
      <template v-if="!loading">
        <template v-if="themeExist">
          <component :is="currentView"></component>
        </template>
        <template v-else>
          <component :is="'template-reporter'"></component>
        </template>
      </template>
    </main-layout>
  </div>
</template>

<script>
import reporter from '@/components/view/template/reporter/reporter'
import ecommerce from '@/components/view/template/ecommerce/ecommerce'
import oishineko from '@/components/view/template/oishineko/reporter'
import event from '@/components/view/template/event/Event'
import qualityexpress from '@/components/view/template/qualityexpress/main'
import leologistics from '@/components/view/template/leologistics/main'
import hafele from '@/components/view/template/hafele/main'
import generali from '@/components/view/template/generali/main'
import generalixwarroom from '@/components/view/template/generalixwarroom/main'
import dplus from '@/components/view/template/dplus/main'
import runbetter from '@/components/view/template/runbetter/main'
import scgcareer from '@/components/view/template/scgcareer/main'
import ananda from '@/components/view/template/ananda/main'
import scgallrent from '@/components/view/template/scgallrent/main'
import pttlng from '@/components/view/template/pttlng/main'
import centralhr from '@/components/view/template/centralhr/main'
import bblcareer from '@/components/view/template/bblcareer/main'
import grampablokof from '@/components/view/template/grampablokof/main.vue'
import tero from '@/components/view/template/tero/main.vue'
import mjd from '@/components/view/template/mjd/main.vue'
import toa from '@/components/view/template/toa/main.vue'
import toacrm from '@/components/view/template/toacrm/main.vue'
import yasale from '@/components/view/template/yasale/main.vue'
import toaecoupon from '@/components/view/template/toaecoupon/main.vue'
import plern from '@/components/view/template/plern/main.vue'
import secap from '@/components/view/template/secap/MaintenanceServiceBooking.vue'
import cityfresh from '@/components/view/template/cityfresh/main'

import { mapGetters, mapMutations } from 'vuex'

export default {
  data: function () {
    return {
      // currentView: 'template-reporter'
      themeExist: false,
      loading: true,
      themes: [
        'bec',
        'reporter',
        'ecommerce',
        'sahapan',
        'ecommercebasic',
        'chatty',
        'oishineko',
        'oishineko2',
        'ananda',
        'event',
        'qualityexpress',
        'leologistics',
        'hafele',
        'generali',
        'generalixwarroom',
        'dplus',
        'runbetter',
        'scgcareer',
        'ananda',
        'erawon',
        'scgallrent',
        'pttlng',
        'adminperform',
        'nvbb',
        'ticket',
        'summitcapital',
        'centralhr',
        'bblcareer',
        'lookchingiant',
        'runkan',
        'grampablokof',
        'tero',
        'mjd',
        'scgdistribution',
        'toa',
        'toacrm',
        'yasale',
        'foodguru',
        'toaecoupon',
        'plern',
        'secap',
        'cityfresh',
        'warroom',
        'powerbuy'
      ]
    }
  },
  // name: 'template',
  components: {
    'template-reporter': reporter,
    'template-ecommerce': ecommerce,
    'template-oishineko': oishineko,
    'template-oishineko2': oishineko,
    'template-event': event,
    'template-qualityexpress': qualityexpress,
    'template-leologistics': leologistics,
    'template-hafele': hafele,
    'template-generali': generali,
    'template-generalixwarroom': generalixwarroom,
    'template-dplus': dplus,
    'template-runbetter': runbetter,
    'template-scgcareer': scgcareer,
    'template-ananda': ananda,
    'template-scgallrent': scgallrent,
    'template-pttlng': pttlng,
    'template-centralhr': centralhr,
    'template-bblcareer': bblcareer,
    'template-grampablokof': grampablokof,
    'template-tero': tero,
    'template-mjd': mjd,
    'template-toa': toa,
    'template-toacrm': toacrm,
    'template-yasale': yasale,
    'template-toaecoupon': toaecoupon,
    'template-plern': plern,
    'template-secap': secap,
    'template-cityfresh': cityfresh
  },
  mounted: function () {
    let vm = this
    $.each(vm.themes, function (index, value) {
      if (value == vm.$store.state.selectedBot.theme) {
        vm.themeExist = true
        vm.loading = false
        return false
      }
    })
    vm.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currentView: function () {
      if (!this.$store.state.selectedBot) {
        return null
      }
      let theme = this.$store.state.selectedBot.theme

      if (this.$store.state.shoptheme.includes(theme)) {
        return 'template-ecommerce'
      } else {
        return 'template-' + theme
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/template.vue